import React from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function WaterfallChart({
    title = "Outbreak Reason (%)",
    data = [],  // [{ label: "Food borne", value: 50 }, ...]
    height = 300,
}) {

    // Build cumulative waterfall logic
    let cumulative = 0;
    const startBars = [];
    const valueBars = [];
    const labels = data.map(d => d.label);

    data.forEach((item) => {
        startBars.push(cumulative);   // transparent base
        valueBars.push(item.value);   // actual bar height
        cumulative += item.value;     // update cumulative
    });

    const chartData = {
        labels,
        datasets: [
            // invisible start bars
            {
                label: "start",
                data: startBars,
                backgroundColor: "rgba(0,0,0,0)",
                borderWidth: 0,
                barThickness: 22,
            },
            // actual waterfall bars
            {
                label: "Value",
                data: valueBars,
                backgroundColor: "#2dce89", // green similar to screenshot
                borderColor: "#1fab63",
                borderWidth: 1.4,
                borderRadius: 6,
                barThickness: 22,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },

            tooltip: {
                backgroundColor: "#ffffff",
                borderColor: "#e2e8f0",
                borderWidth: 1,
                titleColor: "#1e293b",
                bodyColor: "#1e293b",
                cornerRadius: 10,
                displayColors: false,
                callbacks: {
                    label: (ctx) => `${ctx.raw}%`,
                },
            },
            datalabels:false
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: "#334155",
                    maxRotation: 45,
                },
            },
            y: {
                stacked: true,
                ticks: {
                    color: "#334155",
                },
                grid: {
                    color: "rgba(0,0,0,0.08)",
                },
            },
        },
    };

    return (
        <div className="bg-white rounded-xl shadow-md p-4 ">
            {/* Header */}
            <div className="flex justify-between items-center mb-3">
                <h3 className="text-sm font-semibold text-slate-700">{title}</h3>
                <i className="fa fa-bars text-lg text-slate-500" />
            </div>

            <div style={{ height }}>
                <Bar data={chartData} options={options} />
            </div>
        </div>
    );
}
